// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-title {
  font-size: 16px;
  color: inherit;
  display: inline;
  background: #0075bc !important;
  padding: 4px 21px;
  color: #fff;
  cursor: pointer;
  border-radius: 20px;
  padding-left: 28px;
}
.panel-title > a:before {
    float: left !important;
    font-family: FontAwesome;
    content:"\\f068";
    padding-right: 5px;
    color: #fff;
    position: relative;
    left: 30px;
}
.panel-title > a.collapsed:before {
    float: left !important;
    content:"\\f067";
    color: #fff;
    position: relative;
    left: 30px;
}
.panel-title > a:hover, 
.panel-title > a:active, 
.panel-title > a:focus  {
    text-decoration:none;
}
.panel-body {
  padding: 15px 40px;
}
.left-block{float: left}
.right-block{float: right}
.panel{border:none;}
.accord-block{float: left;width: 100%;    margin-bottom: 15px;}
.accord-block:last-child{    margin-bottom: 0;}
.panel-group {
 
  background: #fff;
}
.rdesc{padding-top: 0;margin-top: -2px}
.btn-circle {
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  line-height: 1.428571429;
  border-radius: 15px;
}

.bus-name .btn-primary {
border-color: #949599;
position: relative;
top: 42px;
left: -11px;    background-color: #fff;
}
.bg-white .glyphicon {

color: #949599;
}
.client-name {
  color: #d6104c;
  font-weight: bold;
  width: 135px;
  float: right;
}
.client-name span {
  float: left;
  font-size: 13px;
  width: 100%;
  font-weight: normal;
  color: #949599;
}
.btn-gray {
  background-color: #999!important;
}
.edit1{top:7px;}
.btn-marign{margin-bottom: 10px}
#accordion_new b{    color: #00a6c6;}
#accordion_new  .row{    margin-bottom: 7px;}

.panel-body td th ,.panel-body tr td,.panel-body tr th {
  border: 1px solid #ccc;
  padding: 6px 14px;
  text-align: left  !important;
}
.navbar-nav>li>a{
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  font-size: 13px;
  margin-left: -7px;
}
.nav>li>a>img {
  max-width: none;
  width: 32px;
  margin-right: 0px;
  margin-bottom: 3px;

}









.report-output{margin-bottom: 0px;}
.btm-text{text-align: right;
    margin-top: 20px;
    float: right;
    width: 100%;}

    .report-output thead tr th,.report-output tr td {
        padding: 24px 8px !important;
        width: 100px;
    min-width: 172px;
    max-width: 300px;
    text-align: center;
    } 
    
    .report-action-btn span{    background: #00a6c6;
        padding: 5px;
        color: #fff;
        border-radius: 50%;
        font-size: 12px;
        cursor: pointer;}

        .report-action-btn{float: right;width: 100%;text-align: right;
            margin: 5px 0 0 0;}

            .form-horizontal .control-label {
                padding-top: 7px;
                margin-bottom: 0;
                text-align: left;
            }
            .navbar-nav>li>a{
                padding-top: 0px;
                padding-bottom: 0px;
                padding-left: 0px;
                font-size: 13px;
                margin-left: -7px;
            
            }
            .nav>li>a>img {
                max-width: none;
                width: 32px;
                margin-right: 0px;
                margin-bottom: 3px;

            }            

            .report-output  thead tr >th:first-child{width: 250px;text-align: left;} 
            .report-output tbody tr >td:first-child{width: 250px;text-align: left;} 
            .gen-report-tr{
                display: table;
                        width: 100%;
                        table-layout: fixed;
            }
            .gen-report-thead{
                display: table;
                    width: calc(100% - 17px);
                    table-layout: fixed;
            }
            .gen-report-tbody{
                display: block;
                    max-height: 400px;
                    overflow-y: scroll;
            }
            .client-name {
                color: #d6104c;
                font-weight: bold;
                width: 135px;
                float: right;
            }
            .bus-name .btn-primary {
                border-color: #949599;
                position: relative;
                top: 34px;
                left: -11px;
                background-color: #fff;
            }
            .client-name span {
                float: left;
                font-size: 13px;
                width: 100%;
                font-weight: normal;
                color: #949599;
            }
            .text-center{
                text-align: center !important;
            }
            
            .gen-report-header{
                font-weight: bold;
            }
            .shadow.bg-white{height: 120px;    overflow: auto;}
            .shadow.gen-report-bg-white{overflow: auto;}
            @media (max-width: 1024px) and (min-width: 768px){
            .name-outter {
                margin-top: 4px !important;
            }
        }
        .panel-collapse{overflow-x: scroll}
        .minusvalue{
          color:red;
        }




`, "",{"version":3,"sources":["webpack://./src/app/generate-report/generate-report.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;AACA;;;IAGI,oBAAoB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA,YAAY,WAAW;AACvB,aAAa,YAAY;AACzB,OAAO,WAAW,CAAC;AACnB,cAAc,WAAW,CAAC,WAAW,KAAK,mBAAmB,CAAC;AAC9D,6BAA6B,gBAAgB,CAAC;AAC9C;;EAEE,gBAAgB;AAClB;AACA,OAAO,cAAc,CAAC,gBAAgB;AACtC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;AACA,qBAAqB;AACrB,kBAAkB;AAClB,SAAS;AACT,WAAW,KAAK,sBAAsB;AACtC;AACA;;AAEA,cAAc;AACd;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA,OAAO,OAAO,CAAC;AACf,YAAY,mBAAmB;AAC/B,qBAAqB,cAAc,CAAC;AACpC,yBAAyB,kBAAkB,CAAC;;AAE5C;EACE,sBAAsB;EACtB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,kBAAkB;;AAEpB;;;;;;;;;;AAUA,eAAe,kBAAkB,CAAC;AAClC,UAAU,iBAAiB;IACvB,gBAAgB;IAChB,YAAY;IACZ,WAAW,CAAC;;IAEZ;QACI,4BAA4B;QAC5B,YAAY;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB;;IAEA,4BAA4B,mBAAmB;QAC3C,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,eAAe;QACf,eAAe,CAAC;;QAEhB,mBAAmB,YAAY,CAAC,WAAW,CAAC,iBAAiB;YACzD,iBAAiB,CAAC;;YAElB;gBACI,gBAAgB;gBAChB,gBAAgB;gBAChB,gBAAgB;YACpB;YACA;gBACI,gBAAgB;gBAChB,mBAAmB;gBACnB,iBAAiB;gBACjB,eAAe;gBACf,iBAAiB;;YAErB;YACA;gBACI,eAAe;gBACf,WAAW;gBACX,iBAAiB;gBACjB,kBAAkB;;YAEtB;;YAEA,yCAAyC,YAAY,CAAC,gBAAgB,CAAC;YACvE,wCAAwC,YAAY,CAAC,gBAAgB,CAAC;YACtE;gBACI,cAAc;wBACN,WAAW;wBACX,mBAAmB;YAC/B;YACA;gBACI,cAAc;oBACV,wBAAwB;oBACxB,mBAAmB;YAC3B;YACA;gBACI,cAAc;oBACV,iBAAiB;oBACjB,kBAAkB;YAC1B;YACA;gBACI,cAAc;gBACd,iBAAiB;gBACjB,YAAY;gBACZ,YAAY;YAChB;YACA;gBACI,qBAAqB;gBACrB,kBAAkB;gBAClB,SAAS;gBACT,WAAW;gBACX,sBAAsB;YAC1B;YACA;gBACI,WAAW;gBACX,eAAe;gBACf,WAAW;gBACX,mBAAmB;gBACnB,cAAc;YAClB;YACA;gBACI,6BAA6B;YACjC;;YAEA;gBACI,iBAAiB;YACrB;YACA,iBAAiB,aAAa,KAAK,cAAc,CAAC;YAClD,4BAA4B,cAAc,CAAC;YAC3C;YACA;gBACI,0BAA0B;YAC9B;QACJ;QACA,gBAAgB,kBAAkB;QAClC;UACE,SAAS;QACX","sourcesContent":[".panel-title {\r\n  font-size: 16px;\r\n  color: inherit;\r\n  display: inline;\r\n  background: #0075bc !important;\r\n  padding: 4px 21px;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  border-radius: 20px;\r\n  padding-left: 28px;\r\n}\r\n.panel-title > a:before {\r\n    float: left !important;\r\n    font-family: FontAwesome;\r\n    content:\"\\f068\";\r\n    padding-right: 5px;\r\n    color: #fff;\r\n    position: relative;\r\n    left: 30px;\r\n}\r\n.panel-title > a.collapsed:before {\r\n    float: left !important;\r\n    content:\"\\f067\";\r\n    color: #fff;\r\n    position: relative;\r\n    left: 30px;\r\n}\r\n.panel-title > a:hover, \r\n.panel-title > a:active, \r\n.panel-title > a:focus  {\r\n    text-decoration:none;\r\n}\r\n.panel-body {\r\n  padding: 15px 40px;\r\n}\r\n.left-block{float: left}\r\n.right-block{float: right}\r\n.panel{border:none;}\r\n.accord-block{float: left;width: 100%;    margin-bottom: 15px;}\r\n.accord-block:last-child{    margin-bottom: 0;}\r\n.panel-group {\r\n \r\n  background: #fff;\r\n}\r\n.rdesc{padding-top: 0;margin-top: -2px}\r\n.btn-circle {\r\n  width: 30px;\r\n  height: 30px;\r\n  text-align: center;\r\n  padding: 6px 0;\r\n  font-size: 12px;\r\n  line-height: 1.428571429;\r\n  border-radius: 15px;\r\n}\r\n\r\n.bus-name .btn-primary {\r\nborder-color: #949599;\r\nposition: relative;\r\ntop: 42px;\r\nleft: -11px;    background-color: #fff;\r\n}\r\n.bg-white .glyphicon {\r\n\r\ncolor: #949599;\r\n}\r\n.client-name {\r\n  color: #d6104c;\r\n  font-weight: bold;\r\n  width: 135px;\r\n  float: right;\r\n}\r\n.client-name span {\r\n  float: left;\r\n  font-size: 13px;\r\n  width: 100%;\r\n  font-weight: normal;\r\n  color: #949599;\r\n}\r\n.btn-gray {\r\n  background-color: #999!important;\r\n}\r\n.edit1{top:7px;}\r\n.btn-marign{margin-bottom: 10px}\r\n#accordion_new b{    color: #00a6c6;}\r\n#accordion_new  .row{    margin-bottom: 7px;}\r\n\r\n.panel-body td th ,.panel-body tr td,.panel-body tr th {\r\n  border: 1px solid #ccc;\r\n  padding: 6px 14px;\r\n  text-align: left  !important;\r\n}\r\n.navbar-nav>li>a{\r\n  padding-top: 0px;\r\n  padding-bottom: 0px;\r\n  padding-left: 0px;\r\n  font-size: 13px;\r\n  margin-left: -7px;\r\n}\r\n.nav>li>a>img {\r\n  max-width: none;\r\n  width: 32px;\r\n  margin-right: 0px;\r\n  margin-bottom: 3px;\r\n\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.report-output{margin-bottom: 0px;}\r\n.btm-text{text-align: right;\r\n    margin-top: 20px;\r\n    float: right;\r\n    width: 100%;}\r\n\r\n    .report-output thead tr th,.report-output tr td {\r\n        padding: 24px 8px !important;\r\n        width: 100px;\r\n    min-width: 172px;\r\n    max-width: 300px;\r\n    text-align: center;\r\n    } \r\n    \r\n    .report-action-btn span{    background: #00a6c6;\r\n        padding: 5px;\r\n        color: #fff;\r\n        border-radius: 50%;\r\n        font-size: 12px;\r\n        cursor: pointer;}\r\n\r\n        .report-action-btn{float: right;width: 100%;text-align: right;\r\n            margin: 5px 0 0 0;}\r\n\r\n            .form-horizontal .control-label {\r\n                padding-top: 7px;\r\n                margin-bottom: 0;\r\n                text-align: left;\r\n            }\r\n            .navbar-nav>li>a{\r\n                padding-top: 0px;\r\n                padding-bottom: 0px;\r\n                padding-left: 0px;\r\n                font-size: 13px;\r\n                margin-left: -7px;\r\n            \r\n            }\r\n            .nav>li>a>img {\r\n                max-width: none;\r\n                width: 32px;\r\n                margin-right: 0px;\r\n                margin-bottom: 3px;\r\n\r\n            }            \r\n\r\n            .report-output  thead tr >th:first-child{width: 250px;text-align: left;} \r\n            .report-output tbody tr >td:first-child{width: 250px;text-align: left;} \r\n            .gen-report-tr{\r\n                display: table;\r\n                        width: 100%;\r\n                        table-layout: fixed;\r\n            }\r\n            .gen-report-thead{\r\n                display: table;\r\n                    width: calc(100% - 17px);\r\n                    table-layout: fixed;\r\n            }\r\n            .gen-report-tbody{\r\n                display: block;\r\n                    max-height: 400px;\r\n                    overflow-y: scroll;\r\n            }\r\n            .client-name {\r\n                color: #d6104c;\r\n                font-weight: bold;\r\n                width: 135px;\r\n                float: right;\r\n            }\r\n            .bus-name .btn-primary {\r\n                border-color: #949599;\r\n                position: relative;\r\n                top: 34px;\r\n                left: -11px;\r\n                background-color: #fff;\r\n            }\r\n            .client-name span {\r\n                float: left;\r\n                font-size: 13px;\r\n                width: 100%;\r\n                font-weight: normal;\r\n                color: #949599;\r\n            }\r\n            .text-center{\r\n                text-align: center !important;\r\n            }\r\n            \r\n            .gen-report-header{\r\n                font-weight: bold;\r\n            }\r\n            .shadow.bg-white{height: 120px;    overflow: auto;}\r\n            .shadow.gen-report-bg-white{overflow: auto;}\r\n            @media (max-width: 1024px) and (min-width: 768px){\r\n            .name-outter {\r\n                margin-top: 4px !important;\r\n            }\r\n        }\r\n        .panel-collapse{overflow-x: scroll}\r\n        .minusvalue{\r\n          color:red;\r\n        }\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
